var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 809 229"
    },
    height: 229,
    width: 809,
    y: 0,
    x: 0,
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style3",
    type: "text/css"
  }, "\n    .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4db45e}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M218 0v.1c-.1 0-31.6-.1-40 30-7.7 27.6-29.4 103.8-30 105.9h-6s-22.2-77.9-30-106C103.6-.1 72 0 72 0H0v229h72V93h6l42 136h50l42-135.9h6V229h72V0h-72z",
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M481 0s-21.1 1.9-31 24l-51 112h-6V0h-72v229h68s22.1-2 32-24l50-112h6v136h72V0h-68z",
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M581 104v125h72v-73h78c34 0 62.8-21.7 73.5-52H581z",
    className: "st0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 47,
    x2: 809,
    y1: 47,
    x1: 570.919,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop20",
    style: {
      stopColor: "#00b4e6"
    },
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop22",
    style: {
      stopColor: "#088ccb"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M731 0H570.9c8 43.6 40.7 78.6 83 90 9.6 2.6 19.7 4 30.1 4h123.4c1.1-5.2 1.6-10.5 1.6-16 0-43.1-34.9-78-78-78z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.302f01046267de5a20c7980bced0e852.svg";
export { ForwardRef as ReactComponent };